import { CSSProperties } from "@material-ui/styles"

/** Conditionally apply styles in createUseStyles */
function styleIf(condition: unknown, styles: CSSProperties): CSSProperties {
  return condition ? styles : {}
}

export default styleIf
